var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteSale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8496",
    "data-name": "Group 8496",
    transform: "translate(-1691.489 -3003.329)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 20,
    height: 20,
    transform: "translate(1691.489 3003.329)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8495",
    "data-name": "Group 8495",
    transform: "translate(1692.897 3005.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M1756.415,3024.342h-3.71a1.047,1.047,0,0,0-1.046,1.048v1.6a1.046,1.046,0,0,0,1.046,1.048h3.71a1.046,1.046,0,0,0,1.046-1.048v-1.6A1.047,1.047,0,0,0,1756.415,3024.342Z",
    transform: "translate(-1741.665 -3022.342)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 2.244,
    height: 0.548,
    transform: "translate(11.773 6.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M1722.1,3016.537a1.376,1.376,0,1,0-1.376-1.376A1.376,1.376,0,0,0,1722.1,3016.537Z",
    transform: "translate(-1716.595 -3013.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M1715.675,3053.662h-16.053a.7.7,0,0,0-.7.7v.254a.7.7,0,0,0,.7.7h16.053a.7.7,0,0,0,.7-.7v-.254A.7.7,0,0,0,1715.675,3053.662Z",
    transform: "translate(-1698.919 -3046.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M1717.168,3032.592h-3.127a1.333,1.333,0,0,0-1.332,1.332v1.87h.919v-1.21a.284.284,0,1,1,.568,0v1.21h2.816v-1.21a.284.284,0,1,1,.568,0v1.21h.919v-1.87A1.333,1.333,0,0,0,1717.168,3032.592Z",
    transform: "translate(-1710.096 -3029.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M1707.289,3066.592v5.08a1.121,1.121,0,0,0,1.122,1.122h12.044a1.121,1.121,0,0,0,1.122-1.122v-5.08Zm7.873,1.676h-6.427a.474.474,0,1,1,0-.947h6.427a.474.474,0,1,1,0,.947Z",
    transform: "translate(-1705.703 -3056.586)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSale);
export default __webpack_public_path__ + "static/media/white_sale.2e5c7246021362c418db91a7a01f71b4.svg";
export { ForwardRef as ReactComponent };